import { render } from "./HoldingScreen.vue?vue&type=template&id=5e43ad1e&scoped=true"
import script from "./HoldingScreen.vue?vue&type=script&lang=js"
export * from "./HoldingScreen.vue?vue&type=script&lang=js"

import "./HoldingScreen.vue?vue&type=style&index=0&id=5e43ad1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e43ad1e"]])

export default __exports__